import { ITranslations } from "@/types/languages";

export const translations: ITranslations = {
  HomeScreen: {
    title: "Ekran główny",
  },
};
